<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import { mapState } from "vuex";
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "EtiquetasContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	computed: {
		...mapState(["usuario"]),
	},
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("etiquetas_loja")) {
				m.push({
					titulo: "Etiquetas Loja",
					titulo_app: "Loja",
					icon: "mdi-store",
					to: "/etiqueta",
					tooltip: "Gerador de etiqueta de produtos",
				});
			}

      if (this.permissao("etiquetas_deposito")) {
        m.push({
          titulo: "Etiquetas Depósito",
          titulo_app: "Depósito",
          icon: "mdi-package-variant-closed",
          to: "/etiqueta/deposito",
          tooltip: "Gerador de etiqueta de produtos",
        });
      }

      if (this.permissao("etiquetas_gestao_gondola")) {
        m.push({
          titulo: "Gestão de Gôndola",
          titulo_app: "Gôndolas",
          icon: "mdi-tag-search",
          to: "/etiqueta/gestao",
          tooltip: "Gerador de etiqueta de produtos",
        });
      }

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>